(function() {
  "use strict";
  var SEL = '.hb-drawer__ledger form, [class*="email-signup"] form';
  var SENTENCE = "one email each chapter. nothing else.";
  // when the page came up. a form filled and sent inside two seconds is a script, not a person
  var BORN = Date.now();
  var TOO_FAST = 2000;
  function sameOriginAction(form) {
    var raw = form.getAttribute("action");
    if (!raw) return "/contact";
    var url;
    try {
      url = new URL(raw, window.location.href);
    } catch (err) {
      return null;
    }
    if (url.origin !== window.location.origin) return null;
    if (url.protocol !== "http:" && url.protocol !== "https:") return null;
    return url.pathname + url.search;
  }
  function answer(form, word) {
    var row = form.parentNode;
    if (!row) return;
    var note = row.querySelector(".hb-ask-said");
    if (!note) {
      note = document.createElement("p");
      note.className = "hb-ask-said";
      note.setAttribute("role", "status");
      row.insertBefore(note, form.nextSibling);
    }
    note.textContent = word;
    form.setAttribute("data-said", "");
    clearTimeout(form._hbSaidT);
    if (word !== "sent") {
      form._hbSaidT = setTimeout(function() {
        form.removeAttribute("data-said");
        note.remove();
        var i = form.querySelector('input[type="email"]');
        if (i) i.focus();
      }, 2400);
    }
  }
  function plantTrap(form) {
    if (!form || form.querySelector('input[name="website"]')) return;
    // honeypot: off screen, out of the tab order, named for what form bots love to fill
    var t = document.createElement("input");
    t.type = "text";
    t.name = "website";
    t.tabIndex = -1;
    t.autocomplete = "off";
    t.setAttribute("aria-hidden", "true");
    t.style.cssText = "position:absolute;left:-9999px;width:1px;height:1px;opacity:0;";
    form.insertBefore(t, form.firstChild);
  }
  function sayIt(form) {
    var i = form.querySelector('input[type="email"]');
    if (i && i.placeholder !== SENTENCE) i.placeholder = SENTENCE;
    var b = form.querySelector("button[aria-label]");
    if (b && b.getAttribute("aria-label") !== "join") b.setAttribute("aria-label", "join");
  }
  // point Shopify's return_to at the page we are on, with the marker the landing code looks for
  function returnHere(form, key) {
    var rt = form.querySelector('input[name="return_to"]');
    if (!rt) return;
    var u;
    try {
      u = new URL(window.location.href);
    } catch (err) {
      return;
    }
    u.searchParams.set(key, "true");
    rt.value = u.pathname + u.search;
  }
  // we came back from Shopify with its success marker: show "sent" where the form lives, then tidy the address
  function landed() {
    var u;
    try {
      u = new URL(window.location.href);
    } catch (err) {
      return;
    }
    if (u.searchParams.get("customer_posted") !== "true") return;
    var form = document.querySelector(SEL);
    if (form) {
      answer(form, "sent");
      var drawer = form.closest("#hb-menu-drawer");
      if (drawer && !drawer.open) {
        var opener = document.querySelector(".hb-bar3 [data-hb-bar-menu]");
        if (opener && opener.offsetParent !== null) opener.click();
      }
    }
    u.searchParams.delete("customer_posted");
    try {
      history.replaceState(null, "", u.pathname + u.search + u.hash);
    } catch (err) {}
  }
  function plantAll() {
    document.querySelectorAll(SEL).forEach(function(form) {
      plantTrap(form);
      sayIt(form);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", plantAll); else plantAll();
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", landed); else landed();
  setTimeout(plantAll, 1200);
  document.addEventListener("submit", function(e) {
    var form = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    var input = form.querySelector('input[type="email"]');
    var email = input ? input.value.trim() : "";
    if (!email || email.indexOf("@") < 1 || email.indexOf(".") < 2) {
      if (input) input.focus();
      return;
    }
    if (form._hbBusy) return;
    var now = Date.now();
    if (form._hbLast && now - form._hbLast < 1500) return;
    // bots fill the honeypot or fire before a person could have typed; tell them "sent" and drop it
    var trap = form.querySelector('input[name="website"]');
    if (trap && trap.value !== "" || now - BORN < TOO_FAST) {
      answer(form, "sent");
      return;
    }
    returnHere(form, "customer_posted");
    if (!window.fetch || !window.FormData) {
      form.submit();
      return;
    }
    var action = sameOriginAction(form);
    if (!action) {
      answer(form, "try again");
      return;
    }
    var fd = new FormData(form);
    form._hbBusy = true;
    form._hbLast = now;
    fetch(action, {
      method: "POST",
      body: fd,
      credentials: "same-origin",
      redirect: "follow",
      referrerPolicy: "same-origin",
      cache: "no-store"
    }).then(function(r) {
      form._hbBusy = false;
      // Shopify marks a real success by sending us back with _posted=true in the address.
      // anything else (its bot check, a validation error, an unknown page) goes through
      // the browser's ordinary submit so the visitor sees the real outcome, never a fake "sent"
      var posted = r.redirected && r.url.indexOf("_posted=true") !== -1;
      if (!posted) {
        form.submit();
        return;
      }
      answer(form, "sent");
    }).catch(function() {
      form._hbBusy = false;
      answer(form, "try again");
    });
  }, true);
})();